<template>
	<form action="/charge" method="post" id="payment-form" @submit="submitPayment">
		<div class="form-row mb-12" :style="{ opacity: !!loading ? 0.75 : 1 }">
			<label for="card-element">Kreditt- eller debetkort</label>
			<div id="card-element">
				<!-- A Stripe Element will be inserted here. -->
			</div>

			<!-- Used to display Element errors. -->
			<div id="card-errors" role="alert" class="mt-3 error--text"></div>
			<section>
				<dl>
					<dt>Kvittering blir sendt til:&nbsp;</dt>
					<dd>{{ email }}</dd>
				</dl>
			</section>
		</div>
		<v-btn text @click="$emit('cancel')" :disabled="!!loading">Tilbake</v-btn>
		<v-btn color="primary" depressed type="submit" :disabled="!enableSubmitButton" :loading="!!loading" class="ml-3">Betal nå</v-btn>
	</form>
</template>

<script>
export default {
	name: 'stripe-payment-form',
	props: {
		value: null,
		email: null //todo: prop drilling, better solution?
	},
	data() {
		return {
			card: null,
			loading: 0
		};
	},
	computed: {
		enableSubmitButton() {
			return !this.loading;
		}
	},
	methods: {
		/**
		 * Load stripe script from `js.stripe.com` to be PCI compliant: https://stripe.com/docs/web/setup#setup
		 */
		async loadStripe() {
			return new Promise(resolve => {
				this.loading++;
				const stripe = document.createElement('script');
				stripe.src = 'https://js.stripe.com/v3/';
				stripe.async = true;
				stripe.onload = () => {
					this.$root.stripe = window.Stripe(this.$config.stripe.publishableKey);
					this.loading--;
					resolve();
				};

				document.head.appendChild(stripe);
			});
		},

		/**
		 * Stripe - Mounting a new Stripe card Element
		 */
		mountCard() {
			// Construct Stripe Elements. Apply typekit.
			const elements = this.$root.stripe.elements({
				fonts: [{ cssSrc: 'https://use.typekit.net/ysy8kfi.css' }]
			});

			// Create an instance of the card Element.
			this.card = elements.create('card', {
				// Custom styling can be passed to options when creating an Element.
				hidePostalCode: true,
				style: {
					base: {
						color: '#472449',
						fontFamily: 'niveau-grotesk',
						fontSize: '16px',
						iconColor: '#472449'
					}
				}
			});

			// Add an instance of the card Element into the `card-element` <div>.
			this.card.mount('#card-element');

			// Elements validates user input as it is typed.
			this.card.addEventListener('change', ({ error }) => {
				const displayError = document.getElementById('card-errors');
				if (error) displayError.textContent = error.message;
				else displayError.textContent = '';
			});
		},

		async submitPayment(event) {
			event.preventDefault();
			this.loading++;

			const { paymentMethod, error } = await this.$root.stripe.createPaymentMethod('card', this.card);

			// Process and send paymentMethod.id to create/confirm payment intent.
			if (!error) this.$emit('submit', paymentMethod.id);
			// Else, inform the user about errors.
			else {
				const errorElement = document.getElementById('card-errors');
				errorElement.textContent = error.message;
			}

			this.loading--;
		}
	},
	async mounted() {
		// Load stripe (if not already loaded)
		if (!this.$root.stripe) {
			await this.loadStripe();
		}

		// Mount card
		this.mountCard();
	}
};
</script>

<style lang="scss" scoped>
#payment-form {
	label {
		font-weight: 700;
		letter-spacing: 0.04em;
		color: var(--v-primary-base);
		font-size: 12px;
		margin-bottom: 4px;
		display: inline-block;
	}
}

#card-element {
	background-color: var(--v-secondary-lighten1);
	padding: 0.5rem 1rem;
	position: relative;

	&::before,
	&::after {
		content: '';
		position: absolute;
		bottom: -10px;
		border: 3px solid var(--v-primary-base);
		left: 0;
		width: 100%;
	}

	&::before {
		border: 3px solid var(--v-primary-base);
	}

	&::after {
		border: 3px solid var(--v-secondary-base);
		transform: scaleX(0);
		transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
	}

	&.StripeElement--focus::after {
		transform: scaleX(1);
	}
}
dt dd {
	display: inline-block;
}
dt {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.54);
}
#card-errors {
	min-height: 24px;
}
</style>
